"use client";

import { Image } from "@pamperedchef/design-system";
import type { CmsImage } from "@/composites/landing/types";
import * as styles from "./ImageCollage.module.scss";

export interface ImageCollageProps {
	images: CmsImage[];
}

export function ImageCollage({ images }: ImageCollageProps) {
	if (!images.length) return null;

	return (
		<div className={styles["image-collage"]} data-component="ImageCollage">
			{images.map((image, i) => (
				<figure
					key={`${image.url}-${i}`}
					className={styles["image-collage__item"]}
				>
					<Image
						src={image.url}
						alt={image.alt ?? ""}
						className={styles["image-collage__image"]}
						objectFit="cover"
					/>
				</figure>
			))}
		</div>
	);
}
